import { render, staticRenderFns } from "./dropMenuAction.vue?vue&type=template&id=3205648a&scoped=true"
import script from "./dropMenuAction.vue?vue&type=script&lang=js"
export * from "./dropMenuAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205648a",
  null
  
)

export default component.exports